import { Component } from '@angular/core';
import { UilabMatSlideToggleModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface SwitchExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
}

@Component({
    selector: 'avd-switch-examples',
    templateUrl: './switch-examples.component.html',
    styleUrls: ['./switch-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatSlideToggleModule,
    ],
})
export class SwitchExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/docs/components-form-controls-slide-toggle--docs';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/slide-toggle';

    readonly examples: readonly SwitchExample[] = [
        {
            variant: 'basic',
            label: 'Basic Switch',
            description:
                'Use a switch to toggle a single setting on or off immediately.',
            htmlSnippet: `<uilab-mat-slide-toggle aria-label="Enable notifications">
  Enable notifications
</uilab-mat-slide-toggle>`,
        },
    ];
}
